import { Modal } from '../Modal/Modal';
import { Button, type ButtonVariant } from '../Button/Button';
import { nb } from '@/i18n/nb';
import s from './Dialog.module.css';

type DialogProps = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Variant for the confirm button — use 'danger' for destructive actions. */
  confirmVariant?: ButtonVariant;
  onConfirm: () => void;
  onCancel: () => void;
};

export function Dialog({
  open,
  title,
  message,
  confirmLabel = nb.common.confirm,
  cancelLabel = nb.common.cancel,
  confirmVariant = 'primary',
  onConfirm,
  onCancel,
}: DialogProps) {
  return (
    <Modal open={open} onClose={onCancel} title={title}>
      <p className={s.lede}>{message}</p>
      <div className={s.actions}>
        <Button variant="secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
